import { Mail, Activity } from 'lucide-react';
import '../assets/css/footer.css';

/* lucide-react a retiré les icônes de marques (GitHub, LinkedIn...) —
   on utilise donc de petits SVG inline pour ces deux-là. */
const GithubIcon = (props) => (
    <svg viewBox="0 0 24 24" width={20} height={20} fill="currentColor" {...props}>
        <path d="M12 .5C5.73.5.98 5.24.98 11.52c0 5.02 3.26 9.28 7.78 10.78.57.1.78-.25.78-.55 0-.27-.01-1.16-.02-2.11-3.17.69-3.84-1.35-3.84-1.35-.52-1.32-1.27-1.67-1.27-1.67-1.04-.71.08-.7.08-.7 1.15.08 1.75 1.18 1.75 1.18 1.02 1.75 2.68 1.24 3.33.95.1-.74.4-1.24.72-1.53-2.53-.29-5.19-1.27-5.19-5.65 0-1.25.44-2.27 1.18-3.07-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11 11 0 0 1 5.79 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.58.24 2.75.12 3.04.74.8 1.18 1.82 1.18 3.07 0 4.39-2.67 5.36-5.21 5.64.41.36.77 1.06.77 2.14 0 1.55-.01 2.79-.01 3.17 0 .3.2.66.79.55A11.03 11.03 0 0 0 23.02 11.5C23.02 5.24 18.27.5 12 .5Z" />
    </svg>
);
const LinkedinIcon = (props) => (
    <svg viewBox="0 0 24 24" width={20} height={20} fill="currentColor" {...props}>
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.03-1.85-3.03-1.85 0-2.14 1.45-2.14 2.94v5.66H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13ZM7.12 20.45H3.56V9h3.56v11.45Z" />
    </svg>
);

/* ============================================================
   NOTE D'INTEGRATION
   ============================================================
   - CSS inclus ici pour la preview. Dans ton vrai projet, colle
     le contenu de `css` dans '../assets/css/footer.css' et
     remplace <style>{css}</style> par l'import existant.
   - Remplace les liens GitHub/LinkedIn par tes vraies URLs et
     l'email par mahjoubimhmmd@gmail.com (ou celui que tu utilises).
   - Idem que pour Header/Home : a terme, centralise les couleurs
     (--bg, --panel, --green, etc.) dans un seul tokens.css.
   ============================================================ */

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <>
            
            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <Activity size={16} strokeWidth={2.2} />
                            <span>MCODEX</span>
                        </div>
                        <p>
                            Ingénieur software — développement web et support production
                            monétique. 4 ans d'expérience sur des environnements bancaires
                            critiques.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Liens rapides</h4>
                        <ul>
                            <li><a href="/">Accueil</a></li>
                            <li><a href="/projet">Projets</a></li>
                            <li><a href="/contact">Contact</a></li>
                            <li><a href="/CV">CV</a></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Me contacter</h4>
                        <div className="social-links">
                            <a href="https://github.com/ton-pseudo" target="_blank" rel="noopener noreferrer" className="social-icon" title="GitHub">
                                <GithubIcon />
                            </a>
                            <a href="https://linkedin.com/in/ton-profil" target="_blank" rel="noopener noreferrer" className="social-icon" title="LinkedIn">
                                <LinkedinIcon />
                            </a>
                            <a href="mailto:mahjoubimhmmd@gmail.com" className="social-icon" title="Email">
                                <Mail size={20} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <span className="status-dot" />
                    <p>© {currentYear} Mahjoubi Mohammed — Tous droits réservés</p>
                </div>
            </footer>
        </>
    );
};

export default Footer;


